import AutomationError from './AutomationError';
class InvestorDoesNotHaveTaxId extends AutomationError {
    constructor(options) {
        super('The investor does not have tax id configured.', options);
    }
}
export default InvestorDoesNotHaveTaxId;
